export default __webpack_public_path__ + "static/media/history_1950_01.fbb376ea.png";